<template>
  <section
    :class="{ 'shared-radio --horizontal': isHorizontal }"
    class="shared-radio"
  >
    <label v-if="label">{{ label }}</label>
    <div class="buttons-wrapper">
      <ul>
        <li
          v-for="(item, index) in list"
          :key="index"
        >
          <button
            @click.prevent="toggle(item.value)"
            :class="{ active: String(isActive) === String(item.value) }"
          >
            {{ item.label }}
          </button>
        </li>
      </ul>
    </div>
    <slot />
  </section>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    errors: {
      type: Object,
      default: () => {},
    },
    active: {
      type: [String, Number, Boolean],
      default: null,
    },
    isHorizontal: {
      type: [Object, Boolean],
      default: false,
    },
  },
  watch: {
    active(newVal, oldVal) {
      if (this.newVal === oldVal) {
        return
      }
      this.setActiveValue()
    },
    isActive() {
      this.itemToEmit.value = this.isActive
    },
  },
  data() {
    return {
      isActive: null,
      itemToEmit: {
        name: null,
        value: null,
      },
    }
  },
  mounted() {
    this.setItemToEmit()
    this.setActiveValue()
  },
  methods: {
    setActiveValue() {
      if (this.active !== null) {
        this.isActive = this.active
      }
    },
    setItemToEmit() {
      if (this.name) {
        this.itemToEmit.name = this.name
      }
    },
    toggle(val) {
      /* eslint-disable */
      if(this.isActive === val) return
      this.isActive = val 
      this.itemToEmit.value = val
      this.name
        ? this.$emit('toggle', this.itemToEmit)
        : this.$emit('toggle', val)
      /* eslint-enable */
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';

.shared-radio {
  display: flex;
  flex: 0;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0 0 25px 0;
  min-width: 38%;
  position: relative;

  &.shared-radio.--horizontal {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }

  label {
    flex: initial;
  }
}

div {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0;

  div {
    display: flex;
    flex-direction: column;
  }

  &.--horizontal {
    flex-direction: row;
    justify-content: space-between;

    div {
      .inscription & {
        margin: 25px 0;
      }
    }
  }
}

label {
  @include labels;

  .shared-radio.--horizontal & {
    flex-grow: 1;
    padding-right: 10px;
    width: 40%;
  }
}

.buttons-wrapper {
  flex: initial;

  .shared-radio.--horizontal & {
    display: flex;
    justify-content: space-between;
    width: 50%;
  }

  &.shared-radio.--horizontal {
    display: flex;
    flex-grow: 1;
  }
}

ul {
  display: flex;
  flex: 1;
  justify-content: flex-start;
}

li {
  display: flex;
}

button {
  @include transition(0.3s ease);

  background-color: $gray;
  border: none;
  cursor: pointer;
  font-family: $f-graphie-book;
  margin-right: 25px;
  padding: 20px 10px;

  &.active {
    background-color: $orange;
    color: white;
  }
}

.error span {
  @include errorInputs;
}
</style>
